import { getLiveNode } from './fixtures'

// Demo replacement for services/realtime-status.js `subscribeStatus`. Emits the
// curated live `general` node for a device and re-emits every tick so the
// dashboard cards, current age and active alarms look alive. Same signature and
// contract as the real service (callback receives the value at `path`, returns
// an idempotent unsubscribe).

const TICK_MS = 3000

let globalTick = 0
let timer = null
const subscribers = new Set()

function segmentsOf (path) {
  return String(path).split('/').filter(Boolean)
}

// status/{node}/{mac}[/{child}]
function macFromPath (path) {
  const parts = segmentsOf(path)
  return parts[2] || null
}

function childFromPath (path) {
  const parts = segmentsOf(path)
  return parts[3] || null
}

function valueForSubscription (sub) {
  const general = getLiveNode(sub.mac, globalTick)
  if (sub.child === 'general') {
    return general
  }
  if (!sub.child) {
    // Subscribed to the device root: mirror `{ general: {...} }`.
    return general ? { general: general } : null
  }
  return general ? general[sub.child] : null
}

function deliver (sub) {
  try {
    sub.callback(valueForSubscription(sub))
  } catch (err) {
    // A misbehaving subscriber must never break the fan-out to the others.
  }
}

function ensureTimer () {
  if (timer) {
    return
  }
  timer = setInterval(() => {
    globalTick += 1
    subscribers.forEach(deliver)
  }, TICK_MS)
}

export function subscribeStatusDemo (path, callback) {
  if (!path || typeof callback !== 'function') {
    return function noop () {}
  }
  const sub = { path: path, mac: macFromPath(path), child: childFromPath(path), callback: callback }
  subscribers.add(sub)
  ensureTimer()

  // Deliver the initial value asynchronously (matches the real service, which
  // delivers the cached value on subscribe).
  Promise.resolve().then(() => {
    if (subscribers.has(sub)) {
      deliver(sub)
    }
  })

  let active = true
  return function unsubscribe () {
    if (!active) {
      return
    }
    active = false
    subscribers.delete(sub)
    if (subscribers.size === 0 && timer) {
      clearInterval(timer)
      timer = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/demo/mock-realtime.js